import { getV1 } from '@/common/utils/ajax'

const getPlate = (id) => getV1(`plates/${id}`)

const getFacilities = (id, category) => getV1(`plates/${id}/plate_facilities`, {
    category
})

const getPresales = (id, { page, per }) => getV1(`plates/${id}/plate_presales`, {
    page,
    per
})

const getPlates = ({ zones, only_followed, page, per }) => getV1('plates', {
    zones,
    only_followed,
    page,
    per
})

export default {
    getPlate,
    getPlates,
    getFacilities,
    getPresales
}
